import { render, staticRenderFns } from "./EditBlacklistAddress.vue?vue&type=template&id=19729e26&"
import script from "./EditBlacklistAddress.vue?vue&type=script&lang=ts&"
export * from "./EditBlacklistAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports